export default __webpack_public_path__ + "static/media/the-lane-square.b596104e.jpg";